import {InputAdornment, TextField} from "@material-ui/core";
import QRCodeIcon from "../edit/QRCodeIcon";
import React from "react";
import clsx from "clsx";
import {makeStyles} from "@material-ui/styles";

const useStyle = makeStyles(() => {
    return {
        qrCodeTextField: {
            "& svg": {
                width: 24,
                height: 24
            }
        }
    }
})

export default function({onToggleScanner: onToggleScanner, className, ...props}){
    const classes = useStyle()
    return <TextField
        variant="outlined"
        fullWidth
        className={clsx(className, classes.qrCodeTextField)}
        InputProps={{
            endAdornment: <InputAdornment position="end" onClick={onToggleScanner} style={{
                cursor: "pointer"
            }}>
                <QRCodeIcon/>
            </InputAdornment>
        }}
        {...props}
    />
}
